<template>
  <DynamicText
    :id="teamNameFont"
    tag="p"
    styleGroup="Event Name"
    :get="fixtureNameStyle.get"
    :set="fixtureNameStyle.set"
  >
    <span class="versus"> X </span>
  </DynamicText>
</template>

<script lang="ts">
import { composeEvent } from "@fresh8/ad-data-composition/src/betData";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { Brand } from "@fresh8/types/src";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent } from "vue";
import { injectCardNumber, useAnalytics } from "../../../../hooks/useAnalytics";
import DynamicText from "../../../DynamicText.vue";

const useStyles = createUseStyles({});

export default defineComponent({
  name: "Competitors",
  components: {
    DynamicText
  },
  props: {
    eventId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { marketBranding } = injectBrand();
    const cardNumber = injectCardNumber();
    const { handleClick } = useAnalytics(
      { ...props, cardNumber },
      "Event Name"
    );
    const classesRef = useStyles();

    const event = composeEvent(props.eventId);

    return {
      classes: classesRef,
      handleClick,
      // Use the event name if home and away names don't exist
      useEventName: computed(
        () =>
          !(
            event.value?.competitors.away.name.short &&
            event.value?.competitors.home.name.short
          )
      ),
      fixtureNameStyle: {
        get: (brand: Brand | undefined) =>
          brand && brand.adTemplate.market.teamNameFont,
        set: (brand: Brand, value: string) =>
          (brand.adTemplate.market.teamNameFont = value)
      },

      event,
      teamNameFont: computed(() => marketBranding.value?.teamNameFont || "")
    };
  }
});
</script>

<style></style>
